import { Link } from 'react-router-dom'
import { ArrowRight } from 'lucide-react'
import { Reveal } from '@/components/landing/Reveal'
import { ModelHubMockup } from '@/components/landing/VisionMockups'
import { PageOutro, VisionSection } from '@/components/landing/Section'

/** The Model hub page. */
export function ModelHubPage() {
  return (
    <>
      <Hub />
      <PageOutro>
        <h2 className="nv-h2 text-[1.6rem] sm:text-[2rem]">Find a model, then run it locally</h2>
        <p className="mx-auto mt-3 max-w-xl text-[15px] leading-relaxed text-brand-body">The hub is in development. The app already installs and runs local models today.</p>
        <div className="mt-7 flex flex-wrap items-center justify-center gap-3">
          <Link to="/download" className="nv-btn-primary-lg">
            Download NevTan AI <ArrowRight size={16} />
          </Link>
          <Link to="/roadmap" className="nv-btn-outline-lg">See what ships today</Link>
        </div>
      </PageOutro>
    </>
  )
}

function Hub() {
  return (
    <VisionSection
      id="hub"
      eyebrow="Model hub"
      title="Find a model the way you find an app"
      lede="Search and filter by what you want to do, and see what each model needs. Your hardware is already taken into account."
      tone="panel"
      status="building"
    >
      <div className="grid gap-6 lg:grid-cols-[1.25fr_1fr] lg:items-center [&>*]:min-w-0">
        <Reveal>
          <ModelHubMockup />
        </Reveal>
        <Reveal delay={90} className="space-y-3">
          {[
            {
              title: 'Reviewed, not endless',
              body: 'Every model is reviewed and comes from a known source, so you choose on capability rather than guesswork.',
            },
            {
              title: 'Requirements up front',
              body: 'Memory, video memory, and disk space are shown before you download, alongside whether your computer meets them.',
            },
            {
              title: 'Ratings that mean something',
              body: 'Rated on how well a model does the job it claims, not on how many times it has been downloaded.',
            },
          ].map((point) => (
            <div
              key={point.title}
              className="rounded-xl border border-brand-line bg-brand-paper p-4 shadow-card"
            >
              <h3 className="text-[14px] font-bold text-brand-heading">{point.title}</h3>
              <p className="mt-1 text-[13px] leading-relaxed text-brand-muted">{point.body}</p>
            </div>
          ))}
        </Reveal>
      </div>
    </VisionSection>
  )
}

